export default {
    loadEnrichmentData: function(eventId, questions, fetchTime) {
        return {
            type: 'ENRICHMENT_DATA_LOADED',
            eventId,
            questions,
            fetchTime
        }
    },
    updateAnswer: function(eventId, questionData) {
        return {
            type: 'ENRICHMENT_ANSWER_UPDATE',
            eventId,
            questionData
        };
    },
    updateOpenRequiredEnrichmentsCount: (eventId, openRequiredEnrichmentsCount) => ({
        type: 'UPDATE_OPEN_REQUIRED_ENRICHMENTS_COUNT',
        eventId,
        openRequiredEnrichmentsCount
    })
};
